import { _ as __rest } from '../../../tslib.es6-C8rd5pYo.mjs';
import React__default from 'react';
import { BaseButton } from './BaseButton.es.js';

function LegacyButton(_a) {
  var { color = "primary", size = "medium" } = _a, props = __rest(_a, ["color", "size"]);
  return React__default.createElement(BaseButton, Object.assign({ color, size }, props));
}

export { LegacyButton };
//# sourceMappingURL=Button.es.js.map
